export default "__VITE_ASSET__BfOHGirf__"